import { useEffect, useState } from 'react'
import {
	Row,
	Col,
	Card,
	Form,
	InputGroup,
	Button,
	Spinner,
	Modal,
	Alert
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import AuthenticationService from '../../services/authenticationService'

const ResetPassword: React.FC = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { token } = useParams()
	const [isFetching, setIsFetching] = useState(true)
	const [isTokenValid, setIsTokenValid] = useState(false)
	const [emailAddr, setEmailAddr] = useState('')
	const [passwords, setPasswords] = useState({
		password: '',
		confirmPassword: ''
	})
	const [show, setShow] = useState(false)
	const [showModal, setShowModal] = useState(false)
	const [err, setErr] = useState(false)


	const handleSubmit = (event: any) => {
		event.preventDefault()
		event.stopPropagation()
		if (!show) {
			try {
				AuthenticationService.resetPassword(token, passwords.password)
					.then(result => {
						result ? setShowModal(true) : setErr(true)
					})
					.catch(error => console.error(error))
			} catch (error) {
				console.error(error)
				setErr(true)
			}
		}
	}
	useEffect(() => {
		const checkToken = async () => {
			const checkedToken = await AuthenticationService.checkToken(token)
			if (checkedToken && checkedToken.email && checkedToken.exp) {
				setIsTokenValid(true)
				setEmailAddr(checkedToken.email)
			}
			setIsFetching(false)
		}

		if (!isTokenValid) {
			checkToken()
		}

		if (passwords.password.length !== 0 && passwords.confirmPassword.length !== 0) {
			if (passwords.password !== passwords.confirmPassword) setShow(true)
			else setShow(false)
		}

	}, [passwords, isTokenValid, token])

	return (
		<>
			<Row className='justify-content-center'>
				<Col md={6}>
					{isFetching ? <Spinner animation='border' /> : isTokenValid ? (
						<Card className='mt-5'>
							<Card.Body style={{ padding: '50px', textAlign: 'center' }}>
								<h2>{t('reset_password.change_your_password')}</h2>
								<br /><br />
								<Form onSubmit={handleSubmit}>
									<InputGroup>
										<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
											<FontAwesomeIcon icon={faEnvelope} />
										</InputGroup.Text>
										<Form.Control
											size='lg'
											placeholder={emailAddr}
											style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderLeft: '0px', borderColor: '#EBEBEB' }}
											type='email'
											readOnly
										/>
									</InputGroup>

									<br />
									<InputGroup>
										<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
											<FontAwesomeIcon icon={faLock} />
										</InputGroup.Text>
										<Form.Control
											size='lg'
											placeholder={t('login.password')}
											style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderLeft: '0px', borderColor: '#EBEBEB' }}
											type='password'
											value={passwords.password}
											onChange={event => {
												setPasswords({
													...passwords,
													password: event.target.value
												})
											}}
											required
											pattern='.{8,}'
										/>
									</InputGroup>

									<br />
									<InputGroup>
										<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
											<FontAwesomeIcon icon={faLock} />
										</InputGroup.Text>
										<Form.Control
											size='lg'
											placeholder={t('reset_password.confirm_password')}
											style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderLeft: '0px', borderColor: '#EBEBEB' }}
											type='password'
											value={passwords.confirmPassword}
											onChange={event => {
												setPasswords({
													...passwords,
													confirmPassword: event.target.value
												})
											}}
											required
											pattern='.{8,}'
										/>
									</InputGroup>
									<Form.Text muted>
										{t('reset_password.must_contain')}
									</Form.Text>
									{show && <p style={{ color: 'red' }}>{t('reset_password.password_not_match')}</p>}

									<Row>
										<Col style={{ textAlign: 'right', marginTop: '5px' }}>
											<Button onClick={() => navigate('/login')} variant='link'>Login</Button>
										</Col>
									</Row>
									{err && <Alert variant='danger'>Error resetting password, please try again</Alert>}
									<br />
									<Button variant='primary' type='submit' size='lg' style={{ width: '100%', borderRadius: '10px' }}>
										{t('reset_password.change_password')}
									</Button>
									<br /><br />
								</Form>
							</Card.Body>
						</Card>
					) : (
						<Card className='mt-5'>
							<Card.Body style={{ padding: '50px', textAlign: 'center' }}>
								<h2>{t('reset_password.invalid_link')}</h2>
								<p style={{ color: '#6c757d' }}>
									{t('reset_password.there_was_an_error')}<br />
									{t('reset_password.please_try_again')}
								</p>
								<Button onClick={() => navigate('/forgotpassword')}>{t('reset_password.reset_password')}</Button>
							</Card.Body>
						</Card>
					)}
				</Col>
			</Row>
			<Modal
				show={showModal}
				onHide={() => navigate('/login')}
			>
				<Modal.Header closeButton />
				<Modal.Body>
					<p className='text-center'>
						{t('reset_password.password_changed')}<br />
						{t('reset_password.close_this_window')}
					</p>
				</Modal.Body>
			</Modal>
		</>
	)
}


export default ResetPassword
